import { Link } from '@tanstack/react-router'
import { Receipt } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { Card, CardContent } from '~/shared/ui/card'
import { COMPANY_DETAILS_ANCHOR, useCanEditCompanyDetails } from './use-can-edit-company-details'

/** One quiet line on the overview while the company details from the sign-up are still missing. */
export function CompanyDetailsHint() {
  const { data: business } = useCurrentBusiness()
  const canEdit = useCanEditCompanyDetails()
  if (!business?.companyDetailsPending || !canEdit) return null

  return (
    <Card>
      <CardContent className="flex flex-col items-start gap-3 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-start gap-2 text-muted-foreground text-sm">
          <Receipt className="mt-0.5 size-4 shrink-0" />
          {m.companyDetailsHint()}
        </p>
        <Button asChild variant="outline" size="sm">
          <Link to="/dashboard/settings" hash={COMPANY_DETAILS_ANCHOR}>
            {m.companyDetailsHintAction()}
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}
